import React from 'react';

const SearchInput = ({ searchTerm, setSearchTerm }) => {
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    return (
        <div class="form-group d-flex align-items-center flex-row-reverse position-relative">
            <input
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search patients..."
                className="form-control ps-2 bg-transparent border-0 shadow-none"
            />
            <button type="submit" className="p-0 bg-transparent border-0">
                <span className="d-block material-symbols-outlined icon-lg">search</span>
            </button>
        </div>
    );
};

export default SearchInput;